export function serverError(
  state = {
    serverError: false,
  },
  action
) {
  if (action.type.endsWith('DONE')) {
    return {
      ...state,
      serverError: false,
    };
  }
  if (action.type.endsWith('ERROR')) {
    // TODO: I know this code is cancer but entire redux structure is already cancer enough so whatever
    // better than setting this check on 3 different places for admin, supply and demand
    return {
      ...state,
      serverError:
        action.errorMessage === 'Invalid refresh token!'
          ? 'Your session has expired, please log in again'
          : action.errorMessage,
    };
  }
  if (action.type === 'RESET_ERROR_MESSAGE') {
    return {
      ...state,
      serverError: false,
    };
  }
  return state;
}
